module.exports = __webpack_public_path__ + "static/media/YF24_6.e7525864.jpg";